import { PageTable, Header } from "/src/layouts/page";
import ModalManager from "@ebay/nice-modal-react";
import NiceModal from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";

import { useNavigate } from "react-router-dom";
import capitalizeFirstLetter from "../../../../../utils/capitalizeFirstLetter";
import { formatDate } from "/src/utils/formatDate";
import Table from "/src/components/table";
import "./DashboardTable.css";
import "/src/components/UI/Button/IconButton/IconButton.css";
import Icons from "../../../../phone/data/types/Icons";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import getCutToken from "/src/utils/getCutToken";
import dashboardService from "../../services/dashboardService";
import hasPermission from "/src/utils/hasPermission";
import channelService from "../../../channels/services/channelService";
import { Access } from "/src/utils/access";

function DashboardSharedTable() {
    const navigate = useNavigate();
    const toast = useToastDispatchContext();
    const { deleteDashboard, getDashboardsShared } = dashboardService;

    const cells = [
        {
            column: "NAME",
            name: ["dashboard.name", "name", "dashboard.company.name", "origin"],
            //sort: true,
            show: (value) => (
                <span
                    style={{ textDecoration: value[3] == 0 ? "underline dotted" : "" }}
                    title={capitalizeFirstLetter(value[0] + " for " + value[2])}>
                    {capitalizeFirstLetter(value[1] != null ? value[1] : value[0])}{" "}
                    {/* +  (value[3] == 0 ? " for " + value[2] : "") )} */}{" "}
                </span>
            ),
        },
        {
            column: "BOT NAME",
            name: "dashboard.bot.name",
            sort: true,
            show: (value) => capitalizeFirstLetter(value),
        },
        {
            column: "ORGANIZATION",
            name: "company",
            show: (value) => value ? <><img srcSet={value.logo} title={value.name} alt=""></img></> : <></>,
        },
        /*
        {
            column: 'SHARING',
            name: ['origin', "dashboard.company.name"],
            //name : "origin",
            show: (value) => <div className={value[0] == 2 ? "shared_dashboard_table" : value[0] == 1 ?  "" /*"no_shared_dashboard_table"*/ //: "shared_by_dashboard_table"}> {value[0] == 0 && "Shared by " + value[1]} {/* value[0] ==  1 && "Not Shared" */} {value[0] == 2 && "Shared"}</div>
        //},

        {
            column: "DESCRIPTION",
            name: ["dashboard.description", "description", "dashboard.company.name", "origin"],
            show: (value) => (
                <span>
                    {capitalizeFirstLetter(
                        value[1] != null && value[1].length > 0 ? value[1] : value[0].length > 0 ? value[0] : "Empty"
                    )}{" "}
                    {/* +  (value[3] == 0 ? " for " + value[2] : "") )} */}
                </span>
            ),
        },
        {
            column: "LAST UPDATE",
            name: "updated_at",
            sort: true,
            show: (value) => formatDate(value),
        },
        {
            column: "CHANNEL",
            name: "dashboards_channels_links",
            show: (value) => (
                <div className="container_avaibility" title={value.map((element) => "\n" + element.channel.name)}>
                    {" "}
                    <div className={"circle_point " + (value.length == 0 ? "unavailable" : "available")}> </div>{" "}
                    <span style={{ color: "var(--main)" }}>{"(" + value.length + ")"} </span>
                </div>
            ),
        },
    ];

    const filters = [
        //{ type: 'input', placeholder: 'name', name: 'name' },
    ];
    const onClickDelete = async ({ row, deleteRow }) => {
        const { id } = row;
        await ModalManager.show(ApiModal, {
            title: "Delete dashboard " + row.dashboard.name,
            body: "Do you really want to delete the dashboard " + row.dashboard.name,
            api: {
                request: deleteDashboard,
                param: [row.dashboard.id, { id: row.dashboard.id }],
            },
            buttons: [
                { className: "validate", label: "Cancel" },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
            confirm: {
                name: row.dashboard.name,
                fieldName: "the dashboard",
            },
        }).then(() => {
            deleteRow(id);
        });
    };
    const onClickAdd = () => navigate(urlWithRoutingCompany("/dashboard/create"));
    const onClickUpdate = ({ row }) => navigate(urlWithRoutingCompany("/dashboard/update"), { state: { data: row, type: "update" } });

    const onClickShowEditor = ({ row }) => navigate(urlWithRoutingCompany("/dashboard/editor/" + row.id), { state: { data: row, access: Access.Administrator }, });
    const onClickShowEditorViewMode = ({ row }) => navigate(urlWithRoutingCompany("/dashboard/editor/view/" + row.id), { state: { data: row, access: Access.Client } });

    const actions = [
        hasPermission("update_dashboard") && { className: "fas fa-cog action-button edit_action",style: {}, onClick: onClickUpdate,title: "General informations"},
        hasPermission("update_dashboard") && {condition: "origin", condition_match: "0", className: "fas fa-hand-sparkles action-button profil_action", style: { paddingLeft: "8px", paddingRight: "12px" },onClick: onClickShowEditor, title: "Edit structure"},
        hasPermission("update_dashboard") && {className: "fas fa-edit action-button profil_action",style: {},onClick: onClickShowEditorViewMode,title: "Use dashboard"},
        hasPermission("delete_dashboard") && {condition: "origin", condition_match: "0",className: "fas fa-trash action-button delete_action",style: {}, onClick: onClickDelete, title: "Delete"}
    ].filter((action) => action);
    
    const buttons = [hasPermission("create_dashboard") && { icon: "fas fa-plus", onClick: onClickAdd }].filter((button) => button );

    return (
        <>
            <Table
                className="dashboard"
                name="Dashboard"
                cells={cells}
                api={getDashboardsShared}
                actions={actions}
                buttons={buttons}
                filters={filters}></Table>
        </>
    );
}

export default DashboardSharedTable;
